import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { colorPalette } from '~/themes/colors/colorPalette'
import { textStyleKeys } from '~/themes/textStyles'
import { CallTranscript } from '~/types/CallTranscript'
import { convertCallDuration } from '~/utils/formatter'

import { SectionHeader } from './SectionHeader'

interface HoldAndPauseTimeSectionProps {
  transcript: CallTranscript
}

export const HoldAndPauseTimeSection = ({
  transcript,
}: HoldAndPauseTimeSectionProps) => {
  const holdTimeSeconds =
    (transcript.ConversationCharacteristics.NonTalkTime.TotalTimeMillis /
      1000) |
    0

  const callDurationSeconds =
    (transcript.ConversationCharacteristics.TotalConversationDurationMillis /
      1000) |
    0

  const percentageOfCall =
    (callDurationSeconds ? holdTimeSeconds / callDurationSeconds : 0) * 100

  const color =
    percentageOfCall >= 50 ? colorPalette.red[600] : colorPalette.gray[1300]

  return (
    <Flex
      flexDirection="column"
      width="100%"
      gap="1.5rem"
      justifyItems="stretch"
      height="7.125rem"
    >
      <SectionHeader
        title="Hold Time & Pauses"
        tooltipText="This shows how much time the caller spent on hold or in silence, and the percentage of the total call. Longer-than-normal wait times are highlighted in red."
      />
      <Flex flexDirection="column" justifyContent="center" flex="1 0 0">
        <Text textStyle={textStyleKeys.H1} color={color} marginTop="-1rem">
          {convertCallDuration(holdTimeSeconds)}
        </Text>
        <Text textStyle={textStyleKeys.Body3}>
          {percentageOfCall.toFixed(0)}% of call
        </Text>
      </Flex>
    </Flex>
  )
}
